/**
 * GENERATED by `node scripts/sprite-cells.mjs` from `apps/web/src/icons.scss`; do not edit. v1's sprite sheet's cells, in the
 * sheet's own units (500 × 548), by web's class name (DESIGN_SYSTEM.md §5.1, QD6; a
 * `docs/V1_DUPLICATES.md` row). Each app hands its copy of the sheet to `IconAssetsProvider`; mobile's is the same
 * art cut shorter (500 × 525), so a cell below its edge draws nothing there.
 */
export interface SpriteCell {
  x: number;
  y: number;
  width: number;
  height: number;
}

/** the sheet the cells are measured on */
export const SPRITE_SHEET_SIZE = { width: 500, height: 548 } as const;

export const SPRITE_CELLS = {
  "accept-icon": { x: 312, y: 257, width: 24, height: 24 },
  "add-icon": { x: 384, y: 257, width: 20, height: 20 },
  "back-icon": { x: 120, y: 111, width: 20, height: 20 },
  "backorder-icon": { x: 170, y: 79, width: 16, height: 16 },
  "blue-refresh-copy": { x: 142, y: 498, width: 20, height: 20 },
  "calendar": { x: 80, y: 140, width: 16, height: 16 },
  "collapse-icon": { x: 322, y: 334, width: 24, height: 24 },
  "collapse-icon-white": { x: 356, y: 334, width: 24, height: 24 },
  "customer-delight-icon": { x: 131, y: 95, width: 16, height: 16 },
  "customer-info": { x: 296, y: 443, width: 40, height: 40 },
  "customer-offer": { x: 130, y: 335, width: 24, height: 24 },
  "customer-offer-list": { x: 194, y: 335, width: 24, height: 24 },
  "delete-icon": { x: 360, y: 257, width: 24, height: 24 },
  "delete-icon-blue": { x: 288, y: 281, width: 24, height: 24 },
  "dropdown-icon": { x: 48, y: 79, width: 16, height: 16 },
  "eazy-diner": { x: 357, y: 495, width: 32, height: 32 },
  "edit-pencil-icon": { x: 448, y: 110.84, width: 20, height: 20 },
  "eggetarian-icon": { x: 64, y: 80, width: 16, height: 16 },
  "empty-icon": { x: 336, y: 443, width: 40, height: 40 },
  "error-icon": { x: 256, y: 443, width: 40, height: 40 },
  "error-icon-red": { x: 250, y: 79, width: 16, height: 16 },
  "filter-icon": { x: 240, y: 257, width: 24, height: 24 },
  "grid-view-icon": { x: 0, y: 96, width: 15, height: 13 },
  "grid-view-icon-gray": { x: 0, y: 80, width: 15, height: 13 },
  "grid-view-list": { x: 16.5, y: 95, width: 15, height: 14 },
  "grid-view-list-gray": { x: 16.5, y: 79, width: 15, height: 14 },
  "grid-view-simple": { x: 32, y: 95, width: 16, height: 14 },
  "grid-view-simple-gray": { x: 32, y: 79, width: 16, height: 14 },
  "hold-order-icon": { x: 408, y: 256, width: 25, height: 25 },
  "ic-recommended-inactive-items-icon": { x: 0, y: 329, width: 30, height: 30 },
  "ic-recommended-selected-items-icon": { x: 30, y: 329, width: 30, height: 30 },
  "idea-icon": { x: 264, y: 281, width: 24, height: 24 },
  "info-faded": { x: 169, y: 140, width: 16, height: 16 },
  "item-label-group-icon": { x: 348, y: 111, width: 20, height: 20 },
  "label-group-list-item-icon": { x: 46, y: 492, width: 25.03, height: 25 },
  "load-more-icon": { x: 64, y: 95, width: 16, height: 16 },
  "looking-for-rider": { x: 100, y: 111, width: 20, height: 20 },
  "lowInventory": { x: 0, y: 131, width: 30, height: 30 },
  "mark-done-icon": { x: 264, y: 257, width: 24, height: 24 },
  "marked-read-icon": { x: 336, y: 257, width: 24, height: 24 },
  "meal-icon": { x: 189, y: 140, width: 16, height: 16 },
  "no-item-image": { x: 0, y: 443, width: 48, height: 48 },
  "no-result-found": { x: 48, y: 443, width: 48, height: 48 },
  "non-veg-icon": { x: 96, y: 80, width: 17, height: 16 },
  "nopax-logo": { x: 130, y: 79, width: 12, height: 12 },
  "notes-faded": { x: 149, y: 140, width: 16, height: 16 },
  "notification-bell": { x: 308, y: 111, width: 20, height: 20 },
  "notification-order": { x: 186, y: 79, width: 16, height: 16 },
  "order-warning": { x: 218, y: 79, width: 16, height: 16 },
  "order-warning-fill": { x: 328, y: 111, width: 20, height: 20 },
  "pax-faded": { x: 105, y: 140, width: 16, height: 16 },
  "payment-required": { x: 0, y: 395, width: 48, height: 48 },
  "printer-icon": { x: 23.41, y: 492, width: 25, height: 25 },
  "printer-icon-green": { x: 234, y: 79, width: 16, height: 16 },
  "radio-btn-circle-grey": { x: 368, y: 111, width: 20, height: 20 },
  "radio-btn-filled-circle-blue": { x: 408, y: 111, width: 20, height: 20 },
  "reject-icon": { x: 288, y: 257, width: 24, height: 24 },
  "request-approved": { x: 176, y: 443, width: 40, height: 40 },
  "request-icon": { x: 96, y: 443, width: 40, height: 40 },
  "request-pending": { x: 136, y: 443, width: 40, height: 40 },
  "request-rejected": { x: 216, y: 443, width: 40, height: 40 },
  "reservation-icon": { x: 160, y: 111, width: 20, height: 20 },
  "rider-arrived": { x: 40, y: 111, width: 20, height: 20 },
  "rider-assigned": { x: 0, y: 111, width: 20, height: 20 },
  "rider-image": { x: 60, y: 329, width: 30, height: 30 },
  "rider-not-assigned": { x: 20, y: 111, width: 20, height: 20 },
  "rider-on-the-way": { x: 80, y: 111, width: 20, height: 20 },
  "rider-sent": { x: 60, y: 111, width: 20, height: 20 },
  "right-arrow-icon-blue": { x: 112, y: 95, width: 16, height: 16 },
  "rista-ai-icon": { x: 228, y: 140, width: 16, height: 16 },
  "rista-ai-icon-white": { x: 248, y: 140, width: 16, height: 16 },
  "sad-icon": { x: 48, y: 395, width: 48, height: 48 },
  "support-icon": { x: 468, y: 113, width: 20, height: 16 },
  "swiggy-bolt-icon": { x: 75, y: 500, width: 12, height: 12 },
  "table-faded": { x: 129, y: 140, width: 16, height: 16 },
  "tick-blue-circle": { x: 80, y: 95, width: 16, height: 16 },
  "unable-accept": { x: 202, y: 79, width: 16, height: 16 },
  "unread-icon": { x: 112, y: 79, width: 18, height: 16 },
  "veg-icon": { x: 80, y: 80, width: 16, height: 16 },
  "zomato-bulk-icon": { x: 117, y: 500, width: 12, height: 12 },
} as const satisfies Record<string, SpriteCell>;

export type SpriteCellName = keyof typeof SPRITE_CELLS;

/** cells whose art is all white (v1 draws them on a coloured ground), measured on the sheet: shown on a dark tile */
export const SPRITE_CELLS_LIGHT: readonly SpriteCellName[] = ["accept-icon","collapse-icon-white","load-more-icon","notification-bell","notification-order","reject-icon","rista-ai-icon-white","swiggy-bolt-icon","zomato-bulk-icon"];
